export const BASE_URL = process.env.REACT_APP_API_URL || `http://localhost:8080`
export const WS_URL = `ws://localhost:3001/ws/game`

export const DOMAIN = `http://localhost:3000`
